export const HOUSEKEEPING_SEARCH_TERM = 'Housekeeping';

export const WIDGET_WEIGHTS = {
    bizzon: 3,
    dayuse: 11,
    digitalKey: 15,
    expedia: 15,
    flexkeeping: 12,
    hotelsForTrees: 3,
    housekeeping: 12,
    mewsUniversity: 15,
    sms: 15,
    terminalOrder: 10,
    terminalS2: 15,
    uber: 11,
};
